import { updateProfile } from 'flow/actions/profile-actions';
import Loading from 'flow/components/ui-components/Loading';
import Button from 'flow/components/ui-components/Button';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { PriorityItems } from 'flow/utils/profile-utils';
import { generatePath } from 'flow/utils/router-utils';
import { fromJS } from 'immutable';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import Page from '../Page';
import SettingSection from '../SettingSection';

const ProfileAvailabilityPriority = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, profileKey } = useParams<{
        extensionKey: ExtensionKey;
        profileKey: ProfileKey;
    }>();

    const { getProfile } = useProfiles(extensionKey);

    const profile = getProfile(profileKey);

    const [priority, setPriority] = useState<number>();

    useEffect(() => {
        setPriority(profile?.get('priority'));
    }, [profile, profileKey]);

    if (!profile) {
        return <Loading />;
    }

    const onSubmit = () => {
        dispatch(
            updateProfile(
                extensionKey,
                fromJS({
                    key: profileKey,
                    priority: priority,
                }),
            ),
        );

        history.push(
            generatePath(routes['settings.profiles.profileKey.availability'], {
                extensionKey,
                profileKey,
            }),
        );
    };

    return (
        <Page
            header={profile.get('description')}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes['settings.profiles.profileKey.availability'],
                        {
                            extensionKey,
                            profileKey,
                        },
                    ),
                )
            }
        >
            <SettingSection className="text-sm/4">
                {i18next.t('settings.profile.priority')}
            </SettingSection>

            <RadioButton
                name="priority"
                onChange={() => setPriority(75)}
                checked={priority === 75}
            >
                {i18next.t('settings.profile.priority.' + PriorityItems[75])}
            </RadioButton>

            <RadioButton
                name="priority"
                onChange={() => setPriority(50)}
                checked={priority === 50}
            >
                {i18next.t('settings.profile.priority.' + PriorityItems[50])}
            </RadioButton>

            <RadioButton
                name="priority"
                onChange={() => setPriority(25)}
                checked={priority === 25}
            >
                {i18next.t('settings.profile.priority.' + PriorityItems[25])}
            </RadioButton>

            <div className="mt-6 flex justify-end">
                <Button
                    color="primary"
                    className="min-w-max px-5"
                    onClick={onSubmit}
                    disabled={!profile.get('editable')}
                >
                    {i18next.t('navigate.save')}
                </Button>
            </div>
        </Page>
    );
};

export default ProfileAvailabilityPriority;
